import View from './View.js';
import previewView from './previewView.js';
import { URL, MODAL_CLOSE_SEC, TIMEOUT_SEC } from '../config.js';

class AddProductView extends View {
  _parentElement = document.querySelector('.main');
  _errorMessage = 'Add PRoduct View Error Message';
  _message = 'Add PRoduct View Success Message';

  addHandlerAddProduct(handler) {
    this._popupElement.addEventListener('click', function (e) {
      const productForm = e.target.closest('.product__form--upload');
      if (!productForm) return;

      const btnUpload = document.querySelector('.product__form--upload--btn');

      productForm.addEventListener('submit', function (e) {
        e.preventDefault(); // just blocks the default action (such as submitting a form or navigating to another URL)
        e.stopImmediatePropagation(); // prevents the event from bubbling up the DOM tree and prevents any other event handlers on the same element from being executed. It disables multiple submission trigger.
        btnUpload.disabled = true;
        btnUpload.textContent = 'Adding...'; // Update text for feedback

        const form = new FormData(this);

        handler(form);
        // return false;
        setTimeout(() => {
          btnUpload.disabled = false;
          btnUpload.textContent = 'Upload'; // Update text for feedback
        }, MODAL_CLOSE_SEC * 1000);
      });
    });
  }

  _generateMarkup() {
    const markup = `
        <form action="#" class="product__form--upload"  >
          <div class="product__form--fields">
            <label for="name">Product Name:</label>
            <input type="text" id="name" name="name" required/>
          </div>

          <div class="product__form--fields">
            <label for="brand">Brand:</label>
            <input type="text" id="brand" name="brand" required/>
          </div>

          <div class="product__form--fields">
            <label for="tag">Tagline:</label>
            <input type="text" id="tag" name="tag" required/>
          </div>



          <div class="product__form--fields">
            <label for="description">Description:</label>
            <input type="text" id="description" name="description" />
          </div>

          <div class="product__form--fields">
            <label for="">Gender:</label>
            <div class="product__form--fields">
              <p>
                <label for="male">Male:</label>
                <input type="checkbox" id="male" name="gender" value="male" />
              </p>
              <p>
                <label for="female">Female:</label>
                <input type="checkbox" id="female" name="gender" value="female" />
              </p>
            </div>
          </div>

          <div class="product__form--fields">
            <label for="">Made For:</label>
            <div class="product__form--fields">
              <p>
                <label for="kids">Kids:</label>
                <input type="checkbox" id="kids" name="madeFor" value="kids" />
              </p>
              <p>
                <label for="adults">Adults:</label>
                <input
                  type="checkbox"
                  id="adults"
                  name="madeFor"
                  value="adults"
                />
              </p>
              <p>
                <label for="olds">Olds:</label>
                <input type="checkbox" id="olds" name="madeFor" value="olds" />
              </p>
            </div>
          </div>

          <div class="product__form--fields">
            <label for="sizes">Available Sizes:</label>
            <input type="text" id="sizes" name="sizesAvailable" />
          </div>

          <div class="product__form--fields">
            <label for="mrp">MRP:</label>
            <input type="text" id="mrp" name="mrp" />
          </div>

          <div class="product__form--fields">
            <label for="price">Selling Price:</label>
            <input type="text" id="price" name="price" required/>
          </div>

          <div class="product__form--fields">
            <label for="image-cover">Cover Image:</label>
            <input
              type="file"
              accept="image/*"
              id="image-cover"
              name="imageCover"
            />
          </div>

          <div class="product__form--fields">
            <label for="images">Product Images:</label>
            <input
              type="file"
              accept="image/*"
              id="images"
              name="images"
              multiple
            />
          </div>

          <div class="product__form--fields">
            <label for="material">Material:</label>
            <input type="text" id="material" name="material"  />
          </div>

          <div class="product__form--fields">
            <label for="care">Care:</label>
            <input type="text" id="care" name="care"  />
          </div>

          <div class="product__form--fields">
            <label for="use-case">How to use:</label>
            <input type="text" id="use-case" name="useCase"  />
          </div>

          <div class="product__form--fields">
            <label for="features">Features:</label>
            <input type="text" id="features" name="features"  />
          </div>

          <div class="product__form--fields">
            <label for="package-contains">Package Contains:</label>
            <input
              type="text"
              id="package-contains"
              name="packageContains"
              
            />
          </div>

          <div class="product__form--upload--btn-container">
            <button type="submit" class="product__upload product__form--upload--btn">
              Upload
            </button>
            <!-- <button class="product__upload product__form--update--btn">
              Update
            </button> -->
          </div>

        </form>

`;

    return this._addToPopup(markup);
  }
}

export default new AddProductView();
